function write(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue}; ${expires}`;
}

function read(name) {
  if (document.cookie.indexOf(name) > -1) {
    return document.cookie.split(name)[1].split('; ')[0].substr(1);
  }

  return '';
}

function remove(cname) {
  const d = new Date();
  d.setTime(d.getTime() - 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=; ${expires}`;
}

export default { write, read, remove };
